import { combineReducers } from "redux";
import { sidebarReducer } from "./Sidebar/sidebarReducer";
import { authenticationReducer } from "./Authentication/authenticationReducer";
import { invoicesReducer } from "./Invoices/invoicesReducer";
import { clientsReducer } from "./Clients/clientsReducer";
import { shareholdersReducer } from "./Shareholders/shareholdersReducer";
import { transactionReducers } from "./Transactions/transactionReducers";
import { spendReducer } from "./Spends/spendReducer";
import { dashboardReducer } from "./Dashboard/dashboardReducer"; 

export const rootReducer = combineReducers({
  sidebarReducer,
  authenticationReducer,
  dashboardReducer,
  invoicesReducer,
  clientsReducer,
  shareholdersReducer,
  transactionReducers,
  spendReducer,
});
